import { combineSubStores } from '@jarvis.oddle/core/tools/redux/store'
import customisation from 'redux-store/customisation'
import store from 'redux-store/store'
import menu from 'redux-store/menu'
import promotion from 'redux-store/promotion'
import meta from 'redux-store/meta'
import user from 'redux-store/user'
import order from 'redux-store/order'
import checkout from 'redux-store/checkout'
import invoice from 'redux-store/invoice'
import thankyou from 'redux-store/thankyou'
import agreements from 'redux-store/agreements'
import newsletter from 'redux-store/newsletter'
import route from 'redux-store/route'
import paymentProcess from 'redux-store/paymentProcess'
import storeItemAvailability from './storeItemAvailability'

export * as commonActions from 'redux-store/common/actions'

export const { actions, reducers, initialState, storeKeys, initialiseState } =
  combineSubStores({
    customisation,
    store,
    menu,
    promotion,
    meta,
    user,
    order,
    checkout,
    invoice,
    thankyou,
    agreements,
    newsletter,
    route,
    paymentProcess,
    storeItemAvailability
  })
